export const title = 'No data to display';
export const subtitle = 'Try <Bold>refreshing</Bold> the page or check your connection';
